export const timeService = {
    getCurrentTime() {
        return new Date().toLocaleString('en-GB', { timeZone: 'Europe/London' });
    },
    getCurrentDate() {
        const now = new Date();

        const formatter = new Intl.DateTimeFormat('en-GB', {
            timeZone: 'Europe/London',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
        });

        const parts = formatter.formatToParts(now);
        const partsObj = parts.reduce((acc, part) => {
            acc[part.type] = part.value;
            return acc;
        }, {});

        return new Date(
            parseInt(partsObj.year),
            parseInt(partsObj.month) - 1,
            parseInt(partsObj.day),
            parseInt(partsObj.hour),
            parseInt(partsObj.minute),
            parseInt(partsObj.second)
        );
    }
};